import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, ParallaxImage } from "../site/motion";
import { M } from "../../data/site";

export const WaitlistCTA = () => (
  <section data-testid="waitlist-cta" className="relative overflow-hidden border-t border-cyan-400/15 bg-deep">
    <div className="grid-lines absolute inset-0 opacity-60" />
    <div className="relative mx-auto grid max-w-[1440px] items-center gap-12 px-5 py-24 lg:grid-cols-12 lg:px-12 lg:py-32">
      <FadeUp className="lg:col-span-5">
        <ParallaxImage src={M("waitlist.jpg")} alt="Honesti extending a welcoming hand in a warm kitchen" className="aspect-[4/5] rounded-[2rem] glow-edge" strength={8} />
      </FadeUp>
      <FadeUp className="lg:col-span-6 lg:col-start-7" delay={0.1}>
        <p className="eyebrow mb-6">Early access</p>
        <h2 className="font-display text-5xl font-bold leading-[0.98] tracking-tight text-white sm:text-6xl lg:text-7xl">Be first to welcome <span className="text-grad">Honesti</span> home.</h2>
        <p className="mt-7 max-w-lg text-base text-slate-300 md:text-lg">Join the waitlist for early updates, family pilot invitations and first access to HonestGrow™ University and Little Chefs Academy.</p>
        <Link to="/waitlist" data-testid="cta-join-waitlist-btn" className="btn-primary mt-10 !px-9 !py-4 text-lg">Join the Waitlist <ArrowRight className="h-5 w-5" /></Link>
      </FadeUp>
    </div>
  </section>
);
